import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Icon, Text, useTheme } from '@Sage/hoi-poi-ui';
import classNames from 'classnames';
import { getNumberAsLocaleNumber } from 'utils/numbers';
import { getLiteral } from 'utils/getLiteral';

import './styles.scss';

const RecipientsForm = memo(({ selectedRecipients = 0, onAddRecipients, onCancel, onSave }) => {
    const theme = useTheme();

    const safeSelectedRecipients = useMemo(
        () => Math.max(Number(selectedRecipients) || 0, 0),
        [selectedRecipients],
    );

    const hasRecipients = safeSelectedRecipients > 0;
    const formattedSelectedRecipients = useMemo(
        () => getNumberAsLocaleNumber(safeSelectedRecipients),
        [safeSelectedRecipients],
    );

    return (
        <div className="recipients-form">
            <div className="recipients-form__summary">
                <div className="recipients-form__summary-left">
                    <div
                        className={classNames('recipients-form__summary-icon', {
                            'recipients-form__summary-icon--active': hasRecipients,
                        })}
                    >
                        <Icon
                            name="totalRecipients"
                            size="large"
                            color={
                                hasRecipients
                                    ? theme.colors.actionMajor[500]
                                    : theme.colors.grey[500]
                            }
                        />
                    </div>
                    <div className="recipients-form__summary-copy">
                        <Text type="subtitle" medium>
                            {formattedSelectedRecipients}
                        </Text>
                        <Text type="caption" color={theme.colors.textLight.secondary}>
                            {getLiteral('label_recipients_selected')}
                        </Text>
                    </div>
                </div>
                <Button type="primary" icon="personAdd" onClick={onAddRecipients}>
                    {getLiteral('action_add_recipients')}
                </Button>
            </div>

            <div className="recipients-form__actions">
                <Button type="secondary" size="small" onClick={onCancel}>
                    {getLiteral('action_cancel')}
                </Button>
                <Button type="primary" size="small" onClick={onSave}>
                    {getLiteral('action_save')}
                </Button>
            </div>
        </div>
    );
});

RecipientsForm.displayName = 'RecipientsForm';

RecipientsForm.propTypes = {
    selectedRecipients: PropTypes.number,
    onAddRecipients: PropTypes.func,
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
};

export default RecipientsForm;
